import { default as classNames, default as cx } from 'classnames';
import React from 'react';
import { InfoIcon } from '../../ui/icons/icons';

type Props = {
  className?: string;
  children: React.ReactNode;
  // tooltipType?: string;
  optionalClasses?: string;
  isHidden?: boolean;
  // tooltipIcon?: ReactNode;
  tooltipClassname?: string;
  isNegative?: boolean;
};

const Tooltip: React.FC<Props> = ({
  className,
  children,
  optionalClasses,
  isHidden = true,
  tooltipClassname = '',
  isNegative = false,
}) => {
  const icon = <InfoIcon width={16} height={16} className="inline cursor-pointer text-black600" />;

  return (
    <span className={cx('group relative', className)}>
      <div className="flex items-center align-middle">{icon}</div>
      <div
        className={classNames(
          tooltipClassname,
          'absolute -left-3 z-50 rounded-lg px-4 py-3 text-left shadow-tooltip',
          isHidden ? 'hidden group-hover:block' : '',
          'bottom-7 w-40 md:w-60',
          'before:absolute before:left-[20px] before:top-full before:-translate-x-1/2 before:border-l-[7.5px] before:border-r-[7.5px] before:border-t-[7.5px] before:border-l-transparent before:border-r-transparent before:content-[""]',
          isNegative ? 'bg-neutral800 text-white before:border-t-neutral800' : 'bg-white before:border-t-white',
          optionalClasses
        )}
      >
        {children}
        {/* <div className={classNames('tooltip-arrow-down absolute left-[13px] top-full')} /> */}
      </div>
    </span>
  );
};

export default Tooltip;
